import { useEffect, useState, Fragment } from 'react';
import axios from 'axios';
import ListToggle from './ListToggle';
import ModalModifyTizenbo from "./ModalModifyTizenbo";

const TABLE_HEAD = [
    { key: "_client_name", text: "Nom Client" },
    { key: "_app_type", text: "Type d'app" },
    { key: "_authorized", text: "Autorisé" },
    { key: "_pin_code", text: "Code PIN" },
    { key: "_end_date", text: "Date de fin", type: "date" },
    { key: "_last_seen", text: "Dernière connexion", type: "date" },
    { key: "_app_version", text: "Version" },
    // IP publique remontée par le player (PUT /setIp). Le champ s'appelle `_mac_wifi` pour des
    // raisons historiques mais ne contient PAS une MAC. Affiché ici pour que la recherche par IP
    // soit exploitable (chercher une IP sans pouvoir la lire n'a pas d'intérêt).
    { key: "_mac_wifi", text: "IP publique" },
];

function ListNonApprouve() {
    const [datas, setDate] = useState([]);
    const [programmeMap, setProgrammeMap] = useState({});
    const [sortedBy, setSortedBy] = useState();
    const [counter, setCounter] = useState(0);
    const [search, setSearch] = useState('');
    const [showModalModify, setShowModalModify] = useState(false);

    const [choosenClientBo, setChoosenClientBo] = useState({
        _mac_eth: '', _tizen_id: '', _pin_code: '', _client_name: '', _app_type: '',
        _authorized: '', _video_url: '', _video_url_2: '', _video_url_3: '',
        _video_code: '', _video_code_2: '', _video_code_3: '', _end_date: '', id: '',
        _app_version: '', _zoom: '', _display_id: '', _client_id: '', _room_id: '', _id_pdv: ''
    });

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/InterfaceTizenDevice`)
            .then(res => setDate(res.data.filter((auth) => auth._authorized === 'no')))
            .catch(err => console.log(err));

        axios.get(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/gat_all_programme`)
            .then(res => {
                const map = {};
                res.data.forEach(p => { (map[p._pin_code] = map[p._pin_code] || []).push(p); });
                setProgrammeMap(map);
            }).catch(err => console.log(err));
    }, []);

    const contains = (v, t) => String(v ?? '').toLowerCase().includes(t);

    const sorted = [...datas].sort((a, b) => {
        const aVal = a[sortedBy], bVal = b[sortedBy];
        if (typeof aVal === "number" && typeof bVal === "number")
            return counter % 2 === 0 ? aVal - bVal : bVal - aVal;
        const aStr = String(aVal), bStr = String(bVal);
        return counter % 2 === 0 ? aStr.localeCompare(bStr) : bStr.localeCompare(aStr);
    });

    const filteredDatas = sorted.filter((item) => {
        const t = search.toLowerCase();
        if (t === '') return true;
        const relatedProgrammes = programmeMap[(item._pin_code || '').trim()] || [];
        const deviceMatch =
            contains(item._client_name, t) || contains(item._pin_code, t) ||
            contains(item._id_pdv, t) || contains(item._client_id, t) ||
            contains(item._mac_wifi, t) ||      // IP publique du device (remontée par PUT /setIp)
            contains(item._room_id, t) ||       // hash pdv (calleat)
            contains(item._video_code, t) || contains(item._video_code_2, t) || // id calleat / codes
            contains(item._video_url, t) || contains(item._video_url_2, t) || contains(item._video_url_3, t);
        const programmeMatch = relatedProgrammes.some(p =>
            contains(p.idPdv, t) ||             // id_pdv price-eat présent dans les programmes
            contains(p.Videourl1, t) || contains(p.Videourl2, t) || contains(p.Videourl3, t));
        return deviceMatch || programmeMatch;
    });

    const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

    const renderCell = (data, col) => {
        const val = data[col.key];
        if (val === null || val === undefined) return "";
        if (col.type === 'date') return new Date(val).toLocaleString('fr-FR');
        return val;
    };

    return (
        <Fragment>
            <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6">
                <div className="mb-5 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
                    <div>
                        <h1 className="text-xl font-semibold text-slate-800">Devices non approuvés</h1>
                        <p className="text-sm text-slate-500">{filteredDatas.length} device{filteredDatas.length > 1 ? 's' : ''} en attente d'approbation</p>
                    </div>
                    <div className="flex items-center gap-2">
                        <ListToggle />
                        <div className="relative flex h-10 w-full items-center rounded-xl border border-slate-200 bg-white shadow-sm focus-within:border-indigo-500 focus-within:ring-2 focus-within:ring-indigo-500/20 sm:w-96">
                            <svg className="ml-3 h-5 w-5 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                            </svg>
                            <input
                                className="h-full w-full rounded-xl bg-transparent px-3 text-sm text-slate-800 placeholder-slate-400 outline-none"
                                type="text"
                                placeholder="Nom, PIN, id_pdv, id calleat, programme…"
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                            />
                        </div>
                    </div>
                </div>

                <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
                    <div className="overflow-x-auto">
                        <table className="w-full min-w-max text-left">
                            <thead>
                                <tr className="border-b border-slate-200 bg-slate-50">
                                    {TABLE_HEAD.map((head) => (
                                        <th
                                            key={head.key}
                                            className="cursor-pointer whitespace-nowrap px-4 py-3 text-xs font-semibold uppercase tracking-wide text-slate-500 hover:text-slate-700"
                                            onClick={() => { setSortedBy(head.key); setCounter(counter + 1); }}
                                        >
                                            <span className="inline-flex items-center gap-1">
                                                {head.text}
                                                {sortedBy === head.key && <span className="text-indigo-500">{counter % 2 === 0 ? '▲' : '▼'}</span>}
                                            </span>
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {filteredDatas.length === 0 && (
                                    <tr><td colSpan={TABLE_HEAD.length} className="px-4 py-10 text-center text-sm text-slate-400">Aucun device non approuvé.</td></tr>
                                )}
                                {filteredDatas.map((data) => (
                                    <tr
                                        key={data.id}
                                        onClick={() => { setShowModalModify(true); setChoosenClientBo({ ...choosenClientBo, ...data }); }}
                                        className="cursor-pointer border-b border-slate-100 transition-colors last:border-0 hover:bg-indigo-50/40"
                                    >
                                        {TABLE_HEAD.map((col) => (
                                            <td key={`${data.id}-${col.key}`} className="whitespace-nowrap px-4 py-3 text-sm text-slate-700">
                                                {col.key === '_authorized' ? (
                                                    <span className="inline-flex rounded-full bg-amber-100 px-2 py-0.5 text-xs font-medium text-amber-700">{renderCell(data, col)}</span>
                                                ) : renderCell(data, col)}
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="flex items-center justify-end border-t border-slate-100 bg-slate-50 px-4 py-3">
                        <span className="text-sm font-medium text-slate-600">Total : {filteredDatas.length}</span>
                    </div>
                </div>

                <button
                    onClick={scrollToTop}
                    className="fixed bottom-6 right-6 grid h-10 w-10 place-items-center rounded-full bg-white text-slate-500 shadow-md hover:bg-slate-50"
                    aria-label="Remonter"
                >
                    <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M15 11.25l-3-3m0 0l-3 3m3-3v7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                </button>
            </div>
            <ModalModifyTizenbo isVisible={showModalModify} onClose={() => setShowModalModify(false)} choosenClientBo={choosenClientBo} />
        </Fragment>
    );
}
export default ListNonApprouve;
